import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

// Container Styled Component
export const ContainerStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '20rem',

  '@media(max-width: 750px)': {
    height: '12rem',
  },

  '& svg': {
    fontSize: 64,
    color: theme.palette.global.lightgray,
    '@media(max-width: 750px)': {
      fontSize: 48,
    },
  },

  '& h1': {
    color: theme.palette.global.lightgray,
    marginTop: 16,
    '@media(max-width: 750px)': {
      fontSize: 22,
    },
  },
}));
